import {UserRoleType} from "../../client/user/User";

export default class UserRoleResolver {

    static isAdministrator(roles: UserRoleType[] | undefined): boolean {
        if (roles === undefined)
            return false;
        return roles.includes(UserRoleType.ADMINISTRATOR);
    }

    static isOperator(roles: UserRoleType[] | undefined): boolean {
        if (roles === undefined)
            return false;
        return roles.includes(UserRoleType.OPERATOR);
    }

    static isAtLeastOperator(roles: UserRoleType[] | undefined): boolean {
        if (roles === undefined)
            return false;
        return roles.includes(UserRoleType.OPERATOR) || UserRoleResolver.isAdministrator(roles);
    }

    static isAtLeastSubmitter(roles: UserRoleType[] | undefined): boolean {
        if (roles === undefined)
            return false;
        return roles.includes(UserRoleType.SUBMITTER) || UserRoleResolver.isAtLeastOperator(roles);
    }

    static hasStatisticsAccess(roles: UserRoleType[] | undefined): boolean {
        if (roles === undefined)
            return false;
        return roles.includes(UserRoleType.STATISTICS_READER) || UserRoleResolver.isAdministrator(roles);
    }

}
